export default __webpack_public_path__ + "b37b3886f1323e420bbf4e2b88531285.png";